import { useEffect, useState } from "react";

const navs = [
  { href: "#hot", label: "今日热瓜" },
  { href: "#reply", label: "吃瓜神回复" },
  { href: "#review", label: "评论区神评" },
  { href: "#scene", label: "名场面弹幕梗" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于呱呱" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setKeyword("");
    document.querySelector("#reply")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          {/* 品牌 */}
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
              <i className="ri-chat-smile-2-line"></i>
            </span>
            <span className="font-heading text-2xl text-primary-700">呱呱吃瓜</span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navs.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {n.label}
              </a>
            ))}
          </nav>

          {/* 搜索 + 行动 */}
          <div className="hidden items-center gap-2 md:flex">
            <form onSubmit={onSearch} className="relative">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜神回复 / 名场面"
                aria-label="搜索神回复"
                className="w-40 rounded-full border border-background-300 bg-background-50 py-2 pl-9 pr-3 text-sm outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
              />
            </form>
            <a
              href="#contact"
              className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-accent-600"
            >
              投稿吃瓜
            </a>
          </div>

          {/* 移动端开关 */}
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-3-line"}></i>
          </button>
        </div>

        {/* 移动端面板 */}
        {open && (
          <div className="border-t border-background-200 py-3 lg:hidden">
            <nav className="flex flex-col gap-1" aria-label="移动导航">
              {navs.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-primary-50"
                >
                  {n.label}
                </a>
              ))}
              <form
                onSubmit={onSearch}
                className="relative mt-2"
              >
                <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜神回复 / 名场面"
                  aria-label="搜索神回复"
                  className="w-full rounded-full border border-background-300 bg-background-50 py-2.5 pl-9 pr-3 text-sm outline-none placeholder:text-foreground-400"
                />
              </form>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}